/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// component
import Account from 'pages/dashboard/account/account';



/* ========== ~~~~~~~~~~ ACCOUNT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    generalPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.general'),
    adsTxtPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.adsTxt'),
    paymentInfoPermitted: sessionStatus.permissions.includes('settings.paymentInfo'),
    sitesPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.sites') || sessionStatus.permissions.includes('setttings.sites'),
    usersPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.users'),
    permissions: sessionStatus.permissions
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
)(Account));
